import React from "react";
import { useScrollAnimation } from "../hooks/useScrollAnimation";
import { useTranslation } from "../hooks/useTranslation";

function SteelSupply() {
  const { t } = useTranslation();
  const [leftImgRef, leftImgVisible] = useScrollAnimation();
  const [contentRef, contentVisible] = useScrollAnimation();
  const [rightImgRef, rightImgVisible] = useScrollAnimation();

  return (
    <div className="steelsupply-wrapper">
      <div className="steelsupply flex  ">
        <img
          ref={leftImgRef}
          src="/assets/images/imageone.jpg"
          alt=""
          className={leftImgVisible ? "animate-in" : ""}
        />
        <div ref={contentRef} className={contentVisible ? "animate-in" : ""}>
          <h2 className="semi-bold fs-1000">{t("steelSupply.title")}</h2>
          <p className="fs-500 clr-dark ff-inter">
            {t("steelSupply.description")}
          </p>
          <button>{t("steelSupply.contactUs")}</button>
        </div>
        <img
          ref={rightImgRef}
          src="/assets/images/imagetwo.jpg"
          alt=""
          className={rightImgVisible ? "animate-in" : ""}
        />
      </div>
    </div>
  );
}

export default SteelSupply;
